import React from "react";
import ReactDOM from "react-dom";
import SignIn from "./Components/Sign-in/SignIn";
import SignUp from "./Components/Sign-up/SignUp";
import FrontPage from "./Components/FrontPage/FrontPage";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <FrontPage />
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
